/*
 * @author Sergey Kuzhavskiy <Praffesor>
 */
angular.module('popup.employee', ['popup', 'data.employee']);